import { globalTokens } from './global-tokens';
import { getLightTheme } from './light-theme';
import { getDarkTheme } from './dark-theme';

export const getTheme = themeName => {
  const themes = {
    light: () => getLightTheme(globalTokens.light),
    dark: () => getDarkTheme(globalTokens.dark),
  };

  return themes[themeName]?.();
};
